/**
 * 列表头部宽度拖拽自定义指令
 * @param 无
 * @author 王荣磊
 * @creatTime 2019/5/24
 */
import Vue from 'vue'
// IE 下语法：
// IE 下将 CSS 命名转换为驼峰表示法
// font-size --> fontSize
const camelize = (attr) =>
// /\-(\w)/g 正则内的 (\w) 是一个捕获，捕获的内容对应后面 function 的 letter
// 意思是将 匹配到的 -x 结构的 x 转换为大写的 X (x 这里代表任意字母)
  attr.replace(/\-(\w)/g, (all, letter) => letter.toUpperCase())

// 获取css属性 非内联样式 有回流问题
const getCss = (obj, attribute) => {
  // 兼容性
  if (obj) {
    return window.getComputedStyle ? window.getComputedStyle(obj, null)[attribute] : obj.currentStyle[camelize(attribute)]
  }
}
Vue.directive('list-head-drag', {
  bind(el, binding) {
    let changeStyle = new Map()
    el.onmousedown = (e) => {
      // 记录每次移动 x轴数值，只记录x轴 y轴恒定不变 设置初始值
      let startTime = 0
      let endTime = 0// 用于区别click与mousedown
      const preIsFileItemIcon = false; const // 标志是否是第一列文件夹名称列
        preElementClientWidthCache = 0// 缓存要给file-item的值
      let currentX = 0
      let curElement = null
      let preElement = null
      let cursorBtn = null
      let parentElement = null
      let parentElementWidth = 0
      // 取得dom元素
      cursorBtn = e.target || e.srcElement
      curElement = cursorBtn.parentElement
      preElement = curElement.previousSibling
      parentElement = curElement.parentElement
      // 点击目标时“||”目标时触发
      if (cursorBtn.className === 'cursor-movement') {
        // 获取父元素宽度
        parentElementWidth = parseFloat(parentElement.getBoundingClientRect().width)
        // 获取最小宽度
        const curMinWith = getCss(curElement, 'min-width').split('px')[0]
        const preMinWith = getCss(preElement, 'min-width').split('px')[0]
        //  //获取最大宽度
        // let curMaxWith = getCss(curElement,'max-width').split('px')[0],
        //     preMaxWith = getCss(preElement,'max-width').split('px')[0];
        // 获取总宽度并且这是不会变的宽度
        const fixToalWidth = parseFloat(curElement.getBoundingClientRect().width) + parseFloat(preElement.getBoundingClientRect().width)
        // 点击时记录初始x轴值
        currentX = e.pageX
        // 元素鼠标点击事件内绑定onmousemove并且对象是document
        document.onmousemove = (e) => {
          // 记录开始时间
          startTime = new Date().getTime()
          // 移动时记录当前x轴数值
          const newCurrentX = e.pageX
          // 移动差值 用于判断左右移动
          const gapX = currentX - newCurrentX
          // 获取当前两个li的宽度
          const preElementClientWidth = parseFloat(preElement.getBoundingClientRect().width)
          const curElementClientWidth = parseFloat(curElement.getBoundingClientRect().width)
          // 总宽度
          const currentTotal = preElementClientWidth + curElementClientWidth
          // 获取index
          let preHeadIndex = 0
          if (preElement.classList) { // 兼容ie9
            preHeadIndex = parseInt(preElement.classList[0].split('-')[1])
          } else {
            preHeadIndex = parseInt(preElement.className.split(' ')[0].split('-')[1])
          }
          const curHeadIndex = preHeadIndex + 1
          // 保证总宽度不变
          if (gapX > 0) { // 左移
            if (parseFloat(preElementClientWidth - gapX) > parseFloat(preMinWith)) {
              changeStyle.set(preHeadIndex, `${parseFloat(preElementClientWidth - gapX)}px`)
              changeStyle.set(curHeadIndex, `${parseFloat(curElementClientWidth + gapX)}px`)
              preElement.style.width = `${parseFloat(preElementClientWidth - gapX)}px`
              curElement.style.width = `${parseFloat(curElementClientWidth + gapX)}px`
            }
          } else if (gapX < 0) { // 右移
            if (parseFloat(curElementClientWidth - Math.abs(gapX)) > parseFloat(curMinWith)) {
              changeStyle.set(preHeadIndex, `${parseFloat(preElementClientWidth + Math.abs(gapX))}px`)
              changeStyle.set(curHeadIndex, `${parseFloat(curElementClientWidth - Math.abs(gapX))}px`)
              preElement.style.width = `${parseFloat(preElementClientWidth + Math.abs(gapX))}px`
              curElement.style.width = `${parseFloat(curElementClientWidth - Math.abs(gapX))}px`
            }
          }
          // //处理列表内容
          const preFileListItems = document.getElementsByClassName(`item-${preHeadIndex}`)
          const curFileListItems = document.getElementsByClassName(`item-${preHeadIndex + 1}`)
          for (const item of preFileListItems) {
            item.style.width = preElement.style.width
            let itemClassName = ''
            if (item.classList) { // 兼容ie9
              itemClassName = item.classList[1]
            } else {
              itemClassName = item.className.split(' ')[1]
            }
            /* if (itemClassName === 'filelist-icon') {//是文件名那一列
                                item.querySelector('.display-name').style.maxWidth = `${preElementClientWidth-75}px`
                                if (itemClassName === 'filelist-icon') {//是文件名那一列
                                    item.querySelector('.display-name').style.maxWidth = `${preElementClientWidth-75}px`;
                                    preIsFileItemIcon = true;
                                    preElementClientWidthCache = preElementClientWidth-75;
                                }
                            } */
          }
          for (const item of curFileListItems) {
            item.style.width = curElement.style.width
          }
          // 更新currentX
          currentX = newCurrentX
        }
        document.onmouseup = (e) => {
          // 计算时间
          endTime = new Date().getTime()
          if ((endTime - startTime) > 200) {
            parentElement.setAttribute('data-drag', true)
          }
          if (preIsFileItemIcon) { // 传入文件名那一列的改变后宽度
            binding.value(changeStyle, preElementClientWidthCache)
          } else {
            binding.value(changeStyle, false)
          }
          // 重置变量
          currentX = 0
          curElement = null
          preElement = null
          document.onmousemove = null
          document.onmouseup = null
        }
        // 注册一个监听窗口变化的方法
        let alreadyResize = false
        const resizeEvent = () => (() => {
          if (!alreadyResize) {
            alreadyResize = true
            changeStyle = new Map()
            binding.value('resize')
          }
        })(alreadyResize)
        window.removeEventListener('resize', resizeEvent)
        window.addEventListener('resize', resizeEvent)
      }
    }
  },
})
